<script setup>

import { getCurrentInstance, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import tippy from 'tippy.js';

const {content, placement, is, hideOnClick} = defineProps({
  content: String,
  placement: String,
  is: String,
  hideOnClick: {
    type: Boolean,
    default: undefined
  }
})

const node = ref(null)
let instance;

onMounted(() => {
  if (!content) {
    return;
  }
  instance = tippy(node.value, {
    content,
    placement: placement || 'bottom', 
    touch: false,
    hideOnClick,
  });

}) 

onBeforeUnmount(() => {
  instance?.destroy()
})

watch(() => content, () => {  
  instance?.setContent(content)
});

</script>

<template >
  <component :is="is||'div'" ref="node"><slot /></component>
</template>